export const STATUS = {
  updated: { label: "Updated", tone: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  would_update: { label: "Would change", tone: "bg-sky-50 text-sky-800 border-sky-200" },
  unchanged: { label: "Already right", tone: "bg-slate-50 text-slate-600 border-slate-200" },
  special: { label: "Special billing", tone: "bg-violet-50 text-violet-800 border-violet-200" },
  no_subscription: { label: "No subscription", tone: "bg-amber-50 text-amber-800 border-amber-200" },
  no_usage_product: { label: "No usage product", tone: "bg-amber-50 text-amber-800 border-amber-200" },
  failed: { label: "Failed", tone: "bg-rose-50 text-rose-800 border-rose-200" },
};
export const STATUS_ORDER = ["updated", "would_update", "unchanged", "special", "no_subscription", "no_usage_product", "failed"];

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const num = (n) => Number(n || 0).toLocaleString();
export const fmtDay = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "");
export const fmtDayY = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
export const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

export function describeRun(p = {}) {
  if (p.live_test) return `live test · ${p.domains?.[0] || ""}`;
  const parts = [];
  if (p.collect) parts.push(`collect ${fmtDay(p.start)}${p.end !== p.start ? ` → ${fmtDay(p.end)}` : ""}${p.check_only ? " (check only)" : ""}`);
  if (p.usage) parts.push(`usage${p.domains?.length ? ` · ${p.domains.length} domain${p.domains.length === 1 ? "" : "s"}` : ""}`);
  return parts.join(" · ");
}

export function StatusPill({ s, testid }) {
  const m = STATUS[s] || { label: s, tone: "bg-slate-50 text-slate-600 border-slate-200" };
  return <span className={`inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${m.tone}`} data-testid={testid}>{m.label}</span>;
}

export function RunState({ run }) {
  const tone = run.status === "done" ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : run.status === "failed" ? "bg-rose-50 text-rose-700 border-rose-200" : "bg-amber-50 text-amber-700 border-amber-200";
  return <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold capitalize ${tone}`}>{run.status}</span>;
}
